module.exports = __webpack_public_path__ + "static/media/uw.f4215dd5.webp";